import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance30 = () => {
  let winners = ["297"];
  return <IndividualTable matchType={"3"} gender="M" event="30" subTitle="Zamby" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance30;
